import React, {useState} from 'react';
import Layout from "../components/Layout";
import {useManageContext} from "../App";
import {LanguagesIds} from "../lang/i18n";
import Header from "../components/Header";

export default function Route() {

    const {lang, trip} = useManageContext();
    const [url] = useState(`https://my.cloudex.lv/cloudexdrivemap/default.aspx?key=${trip?.TripKey}&languageId=${LanguagesIds[lang]}`);

    return (
        <Layout>
            <Header />
            <iframe title="Map" src={url} style={{width: '100%', flex: 1, height: (window.innerHeight - 150) + 'px'}}></iframe>
        </Layout>
    )
}